import { BusinessType } from '../../../constants/business-type';
import { Deserializable } from '../../deserializable';
import { BusinessLevel } from '../../register-form/business-level/business-level';
/**
 * Model of first step of register form
 */
export class BusinessDTO extends Deserializable {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public businessName: string,
    public businessType: BusinessType,
    public businessLevelId: any,
    public businessLevels: BusinessLevel[],
    public email: string,
    public website: string,
    public imgSource: string,
    public address: string,
    public addressNumber: string,
    public postalCode: string,
    public countryId: number,
    public state: string,
    public id: number,
    public active: boolean,
    public phoneNumber: string
  ) {
    super();
  }
}
